import React from "react"
import ConfirmationDialog from "components/modals/ConfirmModal"

export const ConfirmationDialogContext = React.createContext({})

export const ConfirmationDialogProvider = ({ children }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false)
    const [dialogConfig, setDialogConfig] = React.useState({})

    const openDialog = ({ title, message, actionCallback }) => {
        setDialogOpen(true)
        setDialogConfig({ title, message, actionCallback })
    }

    const resetDialog = () => {
        setDialogOpen(false)
        setDialogConfig({})
    }

    const onConfirm = () => {
        resetDialog()
        dialogConfig.actionCallback(true)
    }

    const onDismiss = () => {
        resetDialog()
        dialogConfig.actionCallback(false)
    }

    return (
        <ConfirmationDialogContext.Provider value={{ openDialog }}>
            <ConfirmationDialog
                isOpen={dialogOpen}
                title={dialogConfig?.title}
                bodyText={dialogConfig?.message}
                onConfirm={onConfirm}
                onDismiss={onDismiss}
            />
            {children}
        </ConfirmationDialogContext.Provider>
    )
}
